/**
 *
 * Asynchronously loads the component for Career Advice
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
